import React from 'react';



import { Header, Footer, ScrollTop, ScrollToTop } from './components';
import { HomePage, AboutUs, TestimonialsPage, BlogGrid, BlogList, BlogSingle, Login, Register, ForgotPwd, ShopGrid, ShopList, Cart, Checkout, Contact, ProductSingle, Wishlist, ServiceSingle, TeamSingle, TeamPage, ServicePage, PricingPage, Gallery, EventPage, EventSingle, CareerPage, CareerSingle, CareerForm, CalculatorPage, GetQuotePage, AwardPage, ProcessPage, OrderConfirmation, CarGrid, CarList, CarSingle, Support, PartnersPage, PortfolioPage, PortfolioSingle, Error404, TermServices, PrivacyPolicy, CarCompare, SellCar, DealerPage, DealerSingle, FeaturePage, FaqPage } from './sections';

import { BrowserRouter as Router, Routes, Route } from "react-router-dom";



const App = () => {

  return (

    <div className='App'>

      {/* Component to Scroll to Top on Route Change */}
      <ScrollToTop />

      {/* Render the header component */}
      <Header />

      <Routes>

        {/*Home*/}
        <Route path='/' element={<HomePage />} />

        {/*About*/}
        <Route path='/About-us' element={<AboutUs />} />
        <Route path='/Team' element={<TeamPage />} />  
        <Route path='/Team/:id' element={<TeamSingle />} />    
        <Route path='/Team/TeamSingle' element={<TeamSingle />} /> 
        <Route path='/Testimonials' element={<TestimonialsPage />} /> 
        <Route path='/Faqs' element={<FaqPage />} />    
        <Route path='/Awards' element={<AwardPage />} />    
        <Route path='/Partners' element={<PartnersPage />} />    

        {/*Pages*/}
        <Route path='/Services' element={<ServicePage />} />     
        <Route path='/Services/:id' element={<ServiceSingle />} />    
        <Route path='/Services/ServiceSingle' element={<ServiceSingle />} /> 

        <Route path='/Portfolio' element={<PortfolioPage />} />   
        <Route path='/Portfolio/:id' element={<PortfolioSingle />} />   
        <Route path='/Portfolio/PortfolioSingle' element={<PortfolioSingle />} /> 

        <Route path='/Careers' element={<CareerPage />} />    
        <Route path='/Careers/:id' element={<CareerSingle />} />    
        <Route path='/Careers/CareerSingle' element={<CareerSingle />} /> 
        <Route path='/CareerForm' element={<CareerForm />} />    

        <Route path='/Events' element={<EventPage />} />     
        <Route path='/Events/:id' element={<EventSingle />} />    
        <Route path='/Events/EventSingle' element={<EventSingle />} /> 

        <Route path='/Gallery' element={<Gallery />} />   
        <Route path='/Features' element={<FeaturePage />} />   
        <Route path='/Pricing' element={<PricingPage />} />    

        <Route path='/Error' element={<Error404 />} />   
        <Route path='/ServiceTerms' element={<TermServices />} />   
        <Route path='/PrivacyPolicy' element={<PrivacyPolicy />} />    

        <Route path='/LoanCalculator' element={<CalculatorPage />} />    
        <Route path='/WorkProcess' element={<ProcessPage />} />    
        <Route path='/Support' element={<Support />} />   

        {/*Cars*/}
        <Route path='/Car-Grid' element={<CarGrid />} />  
        <Route path='/Car-List' element={<CarList />} /> 
        <Route path='/Cars' element={<CarGrid />} /> 
        <Route path='/Cars/search/:search' element={<CarGrid />} /> 
        <Route path='/Cars/:id' element={<CarSingle />} />
        <Route path='/Cars/Car-Single' element={<CarSingle />} />
        <Route path='/CarCompare' element={<CarCompare />} />    
        <Route path='/GetQuote' element={<GetQuotePage />} />    
        <Route path='/SellCar' element={<SellCar />} />    

        {/*Dealers*/}
        <Route path='/Dealers' element={<DealerPage />} />     
        <Route path='/Dealers/:id' element={<DealerSingle />} />    
        <Route path='/Dealers/DealerSingle' element={<DealerSingle />} /> 

        {/*Blogs*/}
        <Route path='/Blog-grid' element={<BlogGrid />} /> 
        <Route path='/Blogs/category/:category' element={<BlogList />} /> 
        <Route path='/Blogs/tag/:tag' element={<BlogList />} /> 
        <Route path='/Blogs/search/:search' element={<BlogList />} /> 
        <Route path='/Blog-list' element={<BlogList />} /> 
        <Route path='/Blogs/:id' element={<BlogSingle  />} />
        <Route path='/Blogs/Blog-Single' element={<BlogSingle />} />

        {/*Shop*/}
        <Route path='/Shop-grid' element={<ShopGrid />} />  
        <Route path='/Shop/category/:category' element={<ShopList />} /> 
        <Route path='/Shop/tag/:tag' element={<ShopList />} /> 
        <Route path='/Shop/search/:search' element={<ShopList />} /> 
        <Route path='/Shop-list' element={<ShopList />} />
        <Route path='/Shop/:id' element={<ProductSingle />} />
        <Route path='/Shop/Product-Single' element={<ProductSingle />} /> 
        <Route path='/Wishlist' element={<Wishlist />} />
        <Route path='/Cart' element={<Cart />} />
        <Route path='/Checkout' element={<Checkout />} />
        <Route path='/OrderConfirmation' element={<OrderConfirmation />} />
        <Route path='/Login' element={<Login />} />  
        <Route path='/Register' element={<Register />} /> 
        <Route path='/Forgot-pwd' element={<ForgotPwd />} /> 

        {/*Contact*/}
        <Route path='/contact-us' element={<Contact />} /> 

      </Routes>

      {/* Render the footer component */}
      <Footer />

      {/* Scroll to top button */}
      <ScrollTop />
      
    </div>

  )
}

export default App;
